import { render, staticRenderFns } from "./HubSection.vue?vue&type=template&id=1cf7cd06&scoped=true"
import script from "./HubSection.vue?vue&type=script&lang=js"
export * from "./HubSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf7cd06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf7cd06')) {
      api.createRecord('1cf7cd06', component.options)
    } else {
      api.reload('1cf7cd06', component.options)
    }
    module.hot.accept("./HubSection.vue?vue&type=template&id=1cf7cd06&scoped=true", function () {
      api.rerender('1cf7cd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/HubSection.vue"
export default component.exports